// extracted by mini-css-extract-plugin
export default {"defaultText":"DealInfo_defaultText__H4Iag","lostReason":"DealInfo_lostReason__JjmAh","infoText":"DealInfo_infoText__EW02g","errorText":"DealInfo_errorText__zUW5F"};